type EnvType = "staging" | "prod";
export const ENVIROMENT =
  (process.env.REACT_APP_ENVIROMENT as EnvType) ?? "staging";

export const BASE_SHAPES_URL =
  "https://3549-unearth-prod.s3.us-west-2.amazonaws.com/appdata/shapes";

export const BASE_APPDATA_URL_MAP = {
  staging: "https://3549-unearth-staging.s3.us-west-2.amazonaws.com/appdata/apps",
  prod: "https://3549-unearth-prod.s3.us-west-2.amazonaws.com/appdata/apps",
};

export const BASE_APPDATA_URL = BASE_APPDATA_URL_MAP[ENVIROMENT];
